import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import cx from 'classnames';
import { UserInfoWithLzPzus } from 'api';
import { headerMenuMobileUseStyles } from 'components/layout/Header/common/styles/mobile';
import { HeaderMenuList } from 'components/layout/Header/HeaderMenu/HeaderMenuList';
import { headerMenuBaseUseStyles } from 'components/layout/Header/common/styles/base';
import { HeaderProfile } from 'components/ui/HeaderProfile/HeaderProfile';
import { Menu } from '../Header/Header';

type TTypeMenu = 'main' | 'sub';

interface IProp {
  menu: Menu[];
  subMenu: Menu[];
  type: TTypeMenu;
  compact?: boolean;
  user: UserInfoWithLzPzus;
}

export const HeaderMenu: React.FC<IProp> = ({ menu, type, compact, user, subMenu }) => {
  const theme = useTheme();
  const matchesTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const classesBase = headerMenuBaseUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classesMobile = headerMenuMobileUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classes = { ...classesBase, ...classesMobile };

  return (
    <nav className={cx(classes.navbar, compact ? classes.collapsed : '')} style={{ margin: '0 auto' }}>
      <HeaderMenuList menu={menu} subMenu={subMenu} compact={compact} />
      <HeaderProfile user={user} compact={compact} />
    </nav>
  );
};
